module.exports = __webpack_public_path__ + "static/img/back.43b50dd4.svg";